<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>POLITIQUE DE CONFIDENTIALITÉ</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>POLITIQUE DE CONFIDENTIALITÉ</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="privacy-area pt-5">
    <div class="container">
        <div class="privacy-item text-justify" style="font-size: 18px; text-align: justify;" [innerHTML]="appSettingService.value.privacy_policy"></div>
    </div>
</section>